export default [{ key: 'r', action: 'PVL_VIEW_RESET_CAMERA' }];
